export default {
    columns: 12,
    gutter: 1,
};
